import { createRoutine } from 'redux-saga-routines';
import { GET_RENTAL } from './constants';

export const getRental = createRoutine(GET_RENTAL);
